import React from "react";

export interface HashLocatorContextProps {
  newContentWasLoaded: () => void;
}

export const HashLocatorContext = React.createContext<HashLocatorContextProps>({
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  newContentWasLoaded: () => { }
});
